import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';

export default class NewsletterContentComponent extends Component {
  get SELECTORS() {
    return {
      form: '[data-newsletter-form]',
      input: '[data-newsletter-input]',
      moreContainer: '[data-more-container]',
      submitButton: '[data-newsletter-submit]',
      privacyCheckbox: '[data-newsletter-privacy]',
      checkSubmitBtn: '[data-newsletter-privacy]',
    };
  }

  get CLASSES() {
    return {
      success: 'success',
      componentExtended: 'extended',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.form = this.$component.querySelector(this.SELECTORS.form);
    this.input = this.$component.querySelector(this.SELECTORS.input);
    this.moreContainer = this.$component.querySelector(this.SELECTORS.moreContainer);
    this.checkSubmitBtn = this.$component.querySelector(this.SELECTORS.checkSubmitBtn);
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
  }

  showMoreContent(){
    this.input.addEventListener("focus", () => {
      this.moreContainer.style.opacity = 1;
    }, {once: true});
  }

  bindEvents() {
    let ctx = this;

    this.NewsletterLogic.manageNewsletterForm(this);

    // after subscription event
    this.$on(this.$customEvents.NL_MODULE_EVENTS.subscribed, ({event,payload}) => {
      // go logic
      this.NewsletterLogic.afterSubscription(ctx);
    });
  }

  render() {
    this.bindEvents();
    this.showMoreContent();
  }
}
